// src/domains/core/dashboard/components/widgets/health/OuraStepsWidget.tsx

import { Footprints } from "lucide-react";
import { type FC } from "react";

import { StepsCard, useOptimizedActivity } from "@/domains/health/oura";

import { useWidgetConfig } from "../../../hooks/useWidgetConfig";
import { WIDGET_IDS } from "../../../store/widgetRegistry";
import { WidgetContainer } from "../base";

/**
 * OuraStepsWidget - Zeigt tägliche Schritte mit Streak
 *
 * @returns {JSX.Element} Oura steps widget component
 *
 */
export const OuraStepsWidget: FC = () => {
  const { config } = useWidgetConfig(WIDGET_IDS.OURA_STEPS);

  const { loading, steps } = useOptimizedActivity();

  return (
    <WidgetContainer
      description="Oura step tracking"
      icon={<Footprints className="w-5 h-5" />}
      loading={loading}
      size={config?.size ?? "small"}
      title="Daily Steps"
      widgetId={WIDGET_IDS.OURA_STEPS}
    >
      <StepsCard goal={10_000} steps={steps} />
    </WidgetContainer>
  );
};
